class AccountPreference {
    followersAutoAccept = 0
    filledOrderEmails = 0
    followingRequestEmails = 0
    showOrderConfirmation = 0
    culture = "en-US"
    EmailNotifications = false
    PushNotifications = false
    SiteNotifications = true
    TournamentStatus = false
    TournamentWinningStatus = false
    LeaderboardStatus = false
    PlayerGameStatus = false
    PlayerInjuryStatus = false
    PlayerPriceFluctuation = false
    constructor(data) {
        Object.assign(this, data);
    }
}

export default AccountPreference;